import {
  Box,
  Collapse,
  Container,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "../../axios";
import numeral from "numeral";
import sort from "../../utils/sort";
import { currentCurrency } from "../../features/currencySlice";
import { useSelector } from "react-redux";
import cloneDeep from "lodash/cloneDeep";
import LoadingTableRows from "../CoinsTable/LoadingTableRows";
import { Link } from "react-router-dom";
import moment from "moment";

const useStyles = makeStyles({
  table: {},
});

const useTableStyles = makeStyles({
  tableRow: {
    cursor: "pointer",
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#F0F0F0",
    },
  },
});

function Row({ row, curSymbol }) {
  const classes = useTableStyles();
  return (
    <TableRow
      className={classes.tableRow}
      component={Link}
      to={`/exchanges/${row.exchangeId}`}
      style={{ textDecorationLine: "none" }}
    >
      <TableCell align="left">{row.rank}</TableCell>
      <TableCell align="left">{row.name}</TableCell>
      <TableCell align="right">{row.tradingPairs}</TableCell>
      <TableCell align="right">
        {curSymbol + numeral(row.volumeUsd).format("(0.00a)")}
      </TableCell>
      <TableCell align="right">
        {numeral(row.percentTotalVolume).format("0.00") + "%"}
      </TableCell>
      <TableCell align="right">{moment(row.updated).fromNow()}</TableCell>
    </TableRow>
  );
}

function ExchangeBoardTable() {
  const [origData, setOrigData] = useState([]);
  const [curData, setCurData] = useState([]);
  const [sortedData, setSortedData] = useState([]);

  const currentCurSelected = useSelector(currentCurrency);

  const [loading, setLoading] = useState(true);

  const [tblHeader, setTblHeader] = useState([
    { id: "rank", label: "Rank" },
    { id: "name", label: "Name" },
    { id: "tradingpairs", label: "Trading Pairs" },
    { id: "volume24hr", label: "Volume (24hr)" },
    { id: "total", label: "Total (%)" },
    { id: "updated", label: "Updated" },
  ]);

  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();

  const handleSortClick = (cellId) => {
    const isAsc = orderBy === cellId && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(cellId);
  };

  useEffect(() => {
    setInterval(() => {
      axios
        .get("/exchanges/")
        .then((res) => {
          setOrigData(res.data.data);
        })
        .catch((err) => console.log(err));
    }, 3000);
  }, []);
  useEffect(() => {
    setCurData(cloneDeep(origData));
  }, [origData]);
  useEffect(() => {
    curData.map((d, index) => {
      d.volumeUsd = d.volumeUsd / currentCurSelected.rateUsd;

      curData[index] = d;
      if (loading === true) setLoading(false);
    });
    //console.log(curData[0]);
    setSortedData(sort(curData, order, orderBy, "exchange"));
    //console.log("current currency changed!!", currentCurSelected);
  }, [currentCurSelected, curData, order, orderBy]);
  const classes = useStyles();

  return (
    <TableContainer component={Paper} elevation={10}>
      <Table style={{ widht: 600 }}>
        <TableHead>
          <TableRow>
            {tblHeader.map((header) => {
              return (
                <TableCell
                  align={
                    header.id === "name" || header.id === "rank"
                      ? "left"
                      : "right"
                  }
                  key={header.id}
                  sortDirection={header.id === orderBy ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === header.id}
                    direction={orderBy === header.id ? order : "asc"}
                    onClick={() => {
                      handleSortClick(header.id);
                    }}
                  >
                    {header.label}
                  </TableSortLabel>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <LoadingTableRows numberOfRow={15} numberOfColumn={6} />
          ) : (
            sortedData.map((row) => {
              console.log(row);
              const curSymbol =
                currentCurSelected.currencySymbol !== null
                  ? currentCurSelected.currencySymbol
                  : "";

              return <Row row={row} curSymbol={curSymbol} key={row.rank} />;
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ExchangeBoardTable;
